import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import conversationService from "@/services/conversation";

export const useConversationsStore = defineStore("conversations", () => {
  const toast = useToast();
  const loading = ref(false);

  async function createConversation(payload) {
    loading.value = true;
    try {
      const res = await conversationService.createConversation(payload);
      return res;
    } finally {
      loading.value = false;
    }
  }

  async function fetchHistoryOfConversation(payload) {
    loading.value = true;
    try {
      const res = await conversationService.getHistoryOfConversation(payload);
      return res;
    } finally {
      loading.value = false;
    }
  }

  async function fetchAllConversations(payload) {
    loading.value = true;
    try {
      const res = await conversationService.getAllConversations(payload);
      return res;
    } finally {
      loading.value = false;
    }
  }

  async function getLiveKitToken(payload) {
    loading.value = true;
    try {
      const res = await conversationService.getLiveKitToken(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message || "Failed to get LiveKit token");
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    createConversation,
    fetchHistoryOfConversation,
    fetchAllConversations,
    getLiveKitToken,
  };
});
